<div class="flex h-screen justify-center items-center">
    <div class="text-center">
        <div class="pb-5">
          <img class="mx-auto items-center h-88" src="/assets/error-icon.svg" />
        </div>
        <div class="pt-3">
          <span class="block font-medium text-5 text-dark">This link is invalid</span>
        </div>
    </div>
</div>
